import styled, { keyframes, css } from "styled-components";
import { Cell } from "./Common/Table";

const glow = keyframes`
	0% {
    background: var(--color-field-point-2);
    box-shadow: 0 0 0 0 var(--color-field-point-2);
    border: solid 3px rgb(0, 179, 89, 0.2);

  	}

	50% {
    background: var(--color-field-point-2);
    box-shadow: 0 0 0 0px var(--color-field-point-2);
    border: solid 3px rgb(0, 179, 89, 1);
  	}

	
	100% {
    background: var(--color-field-point-2);
    box-shadow: 0 0 0 0 var(--color-field-point-2);
    border: solid 3px rgb(0, 179, 89, 0.2);

  	}
`;

const AnswerCell = styled(Cell)<{ points?: number }>`
  ${({ points }) => {
    if (points === 2) {
      return css`
        background-color: var(--color-field-point-2);
        :hover {
          background-color: var(--color-field-point-2-alt);
          color: gray;
        }
        // animation: ${glow} 2s linear infinite;
      `;
    }
    if (points === 1) {
      return css`
        background-color: var(--color-field-point-1);
        :hover {
          background-color: var(--color-field-point-1-alt);
          color: gray;
        }
      `;
    }
    return css`
      background-color: var(--color-field-point-0);
      :hover {
        background-color: var(--color-field-point-0-alt);
        color: gray;
      }
    `;
  }}
  -webkit-transition: background-color 0.5s, color 0.5s;
  -moz-transition: background-color 0.5s, color 0.5s;
  -o-transition: background-color 0.5s, color 0.5s;
  -ms-transition: background-color 0.5s, color 0.5s;
  transition: background-color 0.5s, color 0.5s;

  :hover {
    .slider {
      visibility: visible;
      opacity: 1;
    }
  }
  position: relative;
`;

export default AnswerCell;
